/**
 * Collaborations Marquee — GSAP-powered infinite horizontal scroll
 *
 * Architecture:
 *  - Two identical .collab-marquee__track elements placed side-by-side
 *  - Both tracks are translated left continuously; when one exits the viewport,
 *    the GSAP repeat mechanism resets the position seamlessly
 *  - Hover slows the tween to 50% speed with a power1.out ease (organic feel)
 *  - Mouse leave eases back to 100% speed
 */

(function () {
    // Wait for DOM + GSAP to be ready
    function initMarquee() {
        const wrapper = document.getElementById('marqueeWrapper');
        if (!wrapper) return;

        const tracks = wrapper.querySelectorAll('.collab-marquee__track');
        if (tracks.length < 2) return;

        // Measure the width of one track (all company names)
        let trackWidth = tracks[0].offsetWidth;

        // Duration in seconds for one full cycle — adjust for desired speed
        // Longer = slower, shorter = faster
        const baseDuration = 30;

        // Create infinite scrolling tween
        // Move both tracks leftward by one trackWidth, then repeat
        let tween = gsap.to(tracks, {
            x: -trackWidth,
            duration: baseDuration,
            ease: 'none', // Linear scroll
            repeat: -1, // Infinite loop
            modifiers: {
                // Use modifiers to wrap the x position for true seamless looping
                x: gsap.utils.unitize((x) => parseFloat(x) % trackWidth),
            },
        });

        // ─── Hover: slow down to 50% speed (desktop only) ──────────────────────
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        if (!isTouchDevice) {
            wrapper.addEventListener('mouseenter', () => {
                gsap.to(tween, {
                    timeScale: 0.5,
                    duration: 0.6,
                    ease: 'power1.out',
                    overwrite: true,
                });
            });

            // ─── Mouse leave: return to 100% speed ─────────────────────────────
            wrapper.addEventListener('mouseleave', () => {
                gsap.to(tween, {
                    timeScale: 1,
                    duration: 0.6,
                    ease: 'power1.out',
                    overwrite: true,
                });
            });
        }

        // ─── Touch: slow on touchstart, resume on touchend ────────────────────
        if (isTouchDevice) {
            wrapper.addEventListener(
                'touchstart',
                () => {
                    gsap.to(tween, {
                        timeScale: 0.15,
                        duration: 0.4,
                        ease: 'power1.out',
                        overwrite: true,
                    });
                },
                { passive: true },
            );

            wrapper.addEventListener(
                'touchend',
                () => {
                    gsap.to(tween, {
                        timeScale: 1,
                        duration: 0.6,
                        ease: 'power1.out',
                        overwrite: true,
                    });
                },
                { passive: true },
            );
        }

        // ─── Handle resize: recalculate track width ────────────────────────
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const newTrackWidth = tracks[0].offsetWidth;
                if (newTrackWidth !== trackWidth) {
                    trackWidth = newTrackWidth;
                    tween.kill();
                    tween = gsap.to(tracks, {
                        x: -trackWidth,
                        duration: baseDuration,
                        ease: 'none',
                        repeat: -1,
                        modifiers: {
                            x: gsap.utils.unitize((x) => parseFloat(x) % trackWidth),
                        },
                    });
                }
            }, 250);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMarquee);
    } else {
    // Small delay to ensure layout is painted and measurements are accurate
        requestAnimationFrame(() => {
            requestAnimationFrame(initMarquee);
        });
    }
}());
